import React, { useEffect, useState, useRef } from "react";

import Linkify from "react-linkify";

import {
  useLocation
} from "react-router-dom";

import moment from "moment";
import "moment/locale/pt-br";

import api from "../services/api";

import {
  AlertCircle,
  Clock,
  Trash,
  CornerUpRight,
  Check
} from "react-feather";

import {
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem
} from "@coreui/react";

//SVG's
import File from "../svgs/File";

import {
  useAuth
} from "../providers/auth";

//opacity menor, deixar igual a encaminhada mas ter o nome
const Messages = ({ replyMessage, chatToBottom, onPaste, messages, setButtonPopupError, setError, setButtonPopupSuccess, setSuccess, updateMessagesById, setButtonPopupForward, setforwardMessages }) => {
  const {
    user
  } = useAuth();

  const location = useLocation();

  const divMessages = useRef(null);
  const messagesEndRef = useRef(null);

  const [loadingUp, setLoadingUp] = useState(false);
  const [loadingDown, setLoadingDown] = useState(false);
  const [messagesList, setMessagesList] = useState([]);
  const [distanceToTop, setDistanceToTop] = useState(0);
  const [count, setCount] = useState(0);

  const renderMessageByType = message => {
    const isDeleted = message.deleted ? "deleted-message" : "";

    const messageId = "#message-id-" + message.id;

    const searchedElementClass = location.hash === messageId ?
      "encountered-element" : "";

    const prospectStyle = { opacity: message.prospect ? "0.8" : "1" };

    const renderDeliveryState = () => {
      if (message.sending) {
        return (
          <div className="deleted-text mb-10">
            <Clock size={12} />
            <span className="ml-10">Enviando...</span>
          </div>
        );
      }

      if (!message.sent) {
        return (
          <div className="deleted-text mb-10">
            <AlertCircle size={12} />
            <span className="ml-10 text-orange">Mensagem não enviada</span>
          </div>
        );
      }

      return null;
    };

    switch (message.type) {

      case "danger": {
        return (
          <div className="messages-date">
            <span>{message.body}</span>
          </div>
        );
      }

      case "date": {
        return (
          <div className="messages-date">
            <span>{message.body}</span>
          </div>
        );
      }

      case "error": {
        return (
          <div className={`message-box ${message.source == "output" ? "right" : "left"} type-error-message`} id={"message-id-" + message.id}>
            <p>{message.body}</p>
          </div>
        );
      }

      case "text": {
        return (
          <div style={prospectStyle} className={`message-box line-break ${searchedElementClass} ${isDeleted} ${message.starred && "msg-starred"} ${message.source == "output" ? "right" : "left"}`} id={"message-id-" + message.id}>

            {message.replyied && <div className="replyied">
              {message.replyied_message?.type === "image" && <div>
                <img src={message.replyied_message?.body} className="replyied__image" />
                <span className="replyied__help">Imagem</span>
              </div>}

              {message.replyied_message?.type === "text" && <div>
                <span className="replyied__help">{message.replyied_message?.body}</span>
              </div>}

              {message.replyied_message?.type === "document" && <div>
                <div className="x-p-5 y-p-5 u-d-inline-block">
                  <File />
                </div>
                <span className="replyied__help">Arquivo</span>
              </div>}

              {message.replyied_message?.type === "video" && <div>
                <video src={message.replyied_message?.body} controls className="replyied__image" />

                <span className="replyied__help">Vídeo</span>
              </div>}

              {message.replyied_message?.type === "audio" && <div>
                <audio controls>
                  <source src={message.replyied_message?.body} />
                </audio>
              </div>}
            </div>}

            {message.forward && <div>
              <span>
                <CornerUpRight fontSize={16} />
              </span>

              {message.forward === "forwarded" && <span className="text-bold ml-10">Mensagem encaminhada</span>}
              {message.prospect && <span className="text-bold ml-10">Mensagem do prospect</span>}
              {message.forward === "frequently_forwarded" && <span className="text-bold ml-10">Mensagem encaminhada com frequência</span>}
            </div>}

            {!message.deleted && <div className="message-action">
              <CDropdown className="message-action-btn">
                <CDropdownToggle color="secondary"></CDropdownToggle>
                <CDropdownMenu>
                  <CDropdownItem onClick={(e) => { e.preventDefault(); setButtonPopupForward(true); setforwardMessages(message.id) }}>Encaminhar</CDropdownItem>
                  <CDropdownItem onClick={e => replyMessage(e, message)}>Responder</CDropdownItem>
                  <CDropdownItem onClick={event => handleFavoriteMessage(event, message.id)}>{message.starred ? "Desfavoritar" : "Favoritar"}</CDropdownItem>
                </CDropdownMenu>
              </CDropdown>
            </div>}

            {message.deleted && <div className="deleted-text mb-10">
              <Trash size={18} />

              <span className="ml-10">
                Mensagem excluída
              </span>
            </div>}

            {renderDeliveryState()}


            <Linkify componentDecorator={(decoratedHref, decoratedText, key) => (
              <a target="blank" href={decoratedHref} key={key}>
                {decoratedText}
              </a>
            )}>
              <p className="line-break">
                {message.body}
              </p>
            </Linkify>

            <span className={`message-box-hour`}>
              {message.readAt !== null && (
                <span style={{ color: '#1AA7EC' }}>
                  <Check />
                </span>
              )}
              {moment(message.createdAt).format("LT")}
            </span>
          </div>
        );
      }

      case "file": case "document": {
        return (
          <div style={prospectStyle} className={`message-box file-box ${searchedElementClass} ${isDeleted} ${message.starred && "msg-starred"} ${message.source == "output" ? "right" : "left"}`} id={"message-id-" + message.id}>
            {message.forward && <div>
              <span>
                <CornerUpRight fontSize={16} />
              </span>

              {message.forward === "forwarded" && <span className="text-bold ml-10">Mensagem encaminhada</span>}
              {message.prospect && <span className="text-bold ml-10">Mensagem do prospect</span>}
              {message.forward === "frequently_forwarded" && <span className="text-bold ml-10">Mensagem encaminhada com frequência</span>}
            </div>}

            <div className="message-action">
              <CDropdown className="message-action-btn">
                <CDropdownToggle color="secondary"></CDropdownToggle>
                <CDropdownMenu>
                  <CDropdownItem><a className="download-item" href={message.body} target="_blank" download>Baixar</a></CDropdownItem>
                  <CDropdownItem onClick={(e) => { e.preventDefault(); setButtonPopupForward(true); }}>Encaminhar</CDropdownItem>
                  <CDropdownItem onClick={event => handleFavoriteMessage(event, message.id)}><a className="download-item">{message.starred ? "Desfavoritar" : "Favoritar"}</a></CDropdownItem>
                </CDropdownMenu>
              </CDropdown>
            </div>

            {message.deleted && <div className="deleted-text mb-10">
              <Trash size={18} />

              <span className="ml-10">
                Mensagem excluída
              </span>
            </div>}

            {renderDeliveryState()}

            <div className="file-wrapper">
              <a href="#">
                <div className="file">
                  <File />
                  <span>Arquivo</span>
                </div>
              </a>
            </div>
            <span className={`message-box-hour`}>
              {message.readAt !== null && (
                <span style={{ color: '#1AA7EC' }}>
                  <Check />
                </span>
              )}
              {moment(message.createdAt).format("LT")}
            </span>
          </div>
        );
      }

      case "image": {
        return (
          <div style={prospectStyle} className={`message-box box-image ${searchedElementClass} ${isDeleted} ${message.starred && "msg-starred"} ${message.source == "output" ? "right" : "left"}`} id={"message-id-" + message.id}>
            {message.forward && <div>
              <span>
                <CornerUpRight fontSize={16} />
              </span>

              {message.forward === "forwarded" && <span className="text-bold ml-10">Mensagem encaminhada</span>}
              {message.prospect && <span className="text-bold ml-10">Mensagem do prospect</span>}
              {message.forward === "frequently_forwarded" && <span className="text-bold ml-10">Mensagem encaminhada com frequência</span>}
            </div>}

            {!message.deleted && <div className="message-action">
              <CDropdown className="message-action-btn">
                <CDropdownToggle color="secondary"></CDropdownToggle>
                <CDropdownMenu>
                  <CDropdownItem><a className="download-item" href={message.body} target="_blank" download>Baixar</a></CDropdownItem>
                  <CDropdownItem onClick={(e) => { e.preventDefault(); setButtonPopupForward(true); setforwardMessages(message.id) }}>Encaminhar</CDropdownItem>
                  <CDropdownItem onClick={event => handleFavoriteMessage(event, message.id)}><a className="download-item">{message.starred ? "Desfavoritar" : "Favoritar"}</a></CDropdownItem>
                </CDropdownMenu>
              </CDropdown>
            </div>}

            {message.deleted && <div className="deleted-text mb-10">
              <Trash size={18} />

              <span className="ml-10">
                Mensagem excluída
              </span>
            </div>}

            {renderDeliveryState()}

            <div className="message-image">
              <a href="#">
                <img src={message.body} />
              </a>
            </div>
            <span className={`message-box-hour`}>
              {message.readAt !== null && (
                <span style={{ color: '#1AA7EC' }}>
                  <Check />
                </span>
              )}
              {moment(message.createdAt).format("LT")}
            </span>
          </div>
        );
      }

      case "sticker": {
        return (
          <div style={prospectStyle} className={`message-box box-sticker ${searchedElementClass} ${isDeleted} ${message.starred && "msg-starred"} ${message.source == "output" ? "right" : "left"}`} id={"message-id-" + message.id}>
            {message.forward && <div>
              <span>
                <CornerUpRight fontSize={16} />
              </span>

              {message.forward === "forwarded" && <span className="text-bold ml-10">Mensagem encaminhada</span>}
              {message.prospect && <span className="text-bold ml-10">Mensagem do prospect</span>}
              {message.forward === "frequently_forwarded" && <span className="text-bold ml-10">Mensagem encaminhada com frequência</span>}
            </div>}

            {!message.deleted && <div className="message-action">
              <CDropdown className="message-action-btn">
                <CDropdownToggle color="secondary"></CDropdownToggle>
                <CDropdownMenu>
                  <CDropdownItem onClick={(e) => { e.preventDefault(); setButtonPopupForward(true); setforwardMessages(message.id) }}>Encaminhar</CDropdownItem>
                  <CDropdownItem onClick={event => handleFavoriteMessage(event, message.id)}><a className="download-item">{message.starred ? "Desfavoritar" : "Favoritar"}</a></CDropdownItem>
                </CDropdownMenu>
              </CDropdown>
            </div>}

            {message.deleted && <div className="deleted-text mb-10">
              <Trash size={18} />

              <span className="ml-10">
                Mensagem excluída
              </span>
            </div>}

            {renderDeliveryState()}

            <div className="message-sticker">
              <a href="#">
                <img src={message.body} />
              </a>
            </div>
            <span className={`message-box-hour`}>
              {message.readAt !== null && (
                <span style={{ color: '#1AA7EC' }}>
                  <Check />
                </span>
              )}
              {moment(message.createdAt).format("LT")}
            </span>
          </div>
        );
      }

      case "video": {
        return (
          <div style={prospectStyle} className={`message-box box-image ${searchedElementClass} ${isDeleted} ${message.starred && "msg-starred"} ${message.source == "output" ? "right" : "left"}`} id={"message-id-" + message.id}>
            {message.forward && <div>
              <span>
                <CornerUpRight fontSize={16} />
              </span>

              {message.forward === "forwarded" && <span className="text-bold ml-10">Mensagem encaminhada</span>}
              {message.prospect && <span className="text-bold ml-10">Mensagem do prospect</span>}
              {message.forward === "frequently_forwarded" && <span className="text-bold ml-10">Mensagem encaminhada com frequência</span>}
            </div>}

            {!message.deleted && <div className="message-action">
              <CDropdown className="message-action-btn">
                <CDropdownToggle color="secondary"></CDropdownToggle>
                <CDropdownMenu>
                  <CDropdownItem><a className="download-item" href={message.body} target="_blank" download>Baixar</a></CDropdownItem>
                  <CDropdownItem onClick={(e) => { e.preventDefault(); setButtonPopupForward(true); setforwardMessages(message.id) }}>Encaminhar</CDropdownItem>
                  <CDropdownItem onClick={event => handleFavoriteMessage(event, message.id)}><a className="download-item">{message.starred ? "Desfavoritar" : "Favoritar"}</a></CDropdownItem>
                </CDropdownMenu>
              </CDropdown>
            </div>}

            {message.deleted && <div className="deleted-text mb-10">
              <Trash size={18} />

              <span className="ml-10">
                Mensagem excluída
              </span>
            </div>}

            {renderDeliveryState()}

            <div className="message-image">
              <video src={message.body} controls />
            </div>
            <span className={`message-box-hour`}>
              {message.readAt !== null && (
                <span style={{ color: '#1AA7EC' }}>
                  <Check />
                </span>
              )}
              {moment(message.createdAt).format("LT")}
            </span>
          </div>
        );
      }

      case "audio": case "voice": {
        return (
          <div style={prospectStyle} className={`message-box box-image ${isDeleted} ${message.starred && "msg-starred"} ${message.source == "output" ? "right" : "left"}`} id={"message-id-" + message.id}>
            {message.forward && <div>
              <span>
                <CornerUpRight fontSize={16} />
              </span>

              {message.forward === "forwarded" && <span className="text-bold ml-10">Mensagem encaminhada</span>}
              {message.prospect && <span className="text-bold ml-10">Mensagem do prospect</span>}
              {message.forward === "frequently_forwarded" && <span className="text-bold ml-10">Mensagem encaminhada com frequência</span>}
            </div>}

            {!message.deleted && <div className="message-action">
              <CDropdown className="message-action-btn">
                <CDropdownToggle color="secondary"></CDropdownToggle>
                <CDropdownMenu>
                  <CDropdownItem href="#"><a className="download-item" href={message.body} target="_blank" download>Baixar</a></CDropdownItem>
                  <CDropdownItem onClick={(e) => { e.preventDefault(); setButtonPopupForward(true); setforwardMessages(message.id) }}>Encaminhar</CDropdownItem>
                  <CDropdownItem onClick={event => handleFavoriteMessage(event, message.id)}><a className="download-item">{message.starred ? "Desfavoritar" : "Favoritar"}</a></CDropdownItem>
                </CDropdownMenu>
              </CDropdown>
            </div>}

            {message.deleted && <div className="deleted-text mb-10">
              <Trash size={18} />

              <span className="ml-10">
                Mensagem excluída
              </span>
            </div>}

            {renderDeliveryState()}

            <div className="message-audio">
              <audio controls>
                <source src={message.body} />
              </audio>
            </div>
            <span className={`message-box-hour`}>
              {message.readAt !== null && (
                <span style={{ color: '#1AA7EC' }}>
                  <Check />
                </span>
              )}
              {moment(message.createdAt).format("LT")}
            </span>
          </div>
        );
      }
    }
  }

  const scrollToBottom = () => {
    // Ensure the bottom anchor aligns with the bottom of the container
    messagesEndRef.current?.scrollIntoView({
      block: "end",
      behavior: "auto"
    });
  }

  const handleFavoriteMessage = async (event, messageId) => {
    event.preventDefault();
    setError("");

    const data = { message_id: messageId };
    const options = { headers: { "Authorization": "Bearer " + user.token } };

    try {
      await api.post("/messages/starred", data, options);

      setButtonPopupSuccess(true);
      setSuccess("Mensagem favoritada com sucesso!");
    } catch (error) {
      setButtonPopupError(true);
      setError("Ocorreu um erro. A mensagem não pode ser favoritada.");
    }
    setLoadingUp(false);
  }

  const handleScroll = async (event) => {
    setCount(count + 1);
    setDistanceToTop(event.currentTarget.scrollTop);
    // subiu o suficiente
    if (distanceToTop < 80 && distanceToTop > 2) {
      // verifica se já nao foi uma requisição pedindo mais (contra floodagem)
      if (loadingUp === false) {
        try {
          // seta como Loading
          setLoadingUp(true);
          // pede mensagens anteriores ao id X
          // falta usar outro metodo e pegar a ultima mensagem (id)
          let chat_id = localStorage.getItem("open_chat")
          let cache = JSON.parse(localStorage.getItem(chat_id))
          let first_message = cache[1].id
          let response = await api.get(`/messages/chats/${chat_id}/previous/${first_message}`, { headers: { "Authorization": "Bearer " + user.token } });

          response.data.forEach(element => {
            cache.unshift(element);
          });

          localStorage.setItem(chat_id, JSON.stringify(cache));
          // seta as novas mensagens
          setMessagesList(JSON.parse(localStorage.getItem(chat_id)));

          // messagesEndRef.current?.scrollIntoView({
          //   behavior: "auto",
          //   block: "center",
          //   inline: "center"
          // });
          // des-seta como Loading
          setLoadingUp(false);

        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  useEffect(() => {
    if (count === 0) {
      scrollToBottom();
    }
  }, [messagesList]);

  useEffect(() => {
    setMessagesList(messages);
    scrollToBottom();
  }, [messages]);

  const findRecentMessages = async (e) => {
    let target = e.currentTarget;
    let scrollHeight = target.scrollHeight - target.offsetHeight;
    let scrollTop = target.scrollTop;

    if (scrollTop === scrollHeight) {

      // console.log("entrou aqui 1")

      // if (loadingDown == false) {
      //   console.log("entrou aqui 2")

      try {
        // seta como Loading
        setLoadingDown(true);
        // pede mensagens anteriores ao id X
        // falta usar outro metodo e pegar a ultima mensagem (id)
        let chat_id = localStorage.getItem("open_chat")
        let cache = JSON.parse(localStorage.getItem(chat_id))
        let last_message = cache[cache.length - 2].id;

        let response = await api.get(`/messages/chats/${chat_id}/next/${last_message}`, { headers: { "Authorization": "Bearer " + user.token } });

        /*response.data.forEach(element => {
          cache.concat(element);
        });*/

        localStorage.setItem(chat_id, JSON.stringify(cache));
        // seta as novas mensagens
        setMessagesList(JSON.parse(localStorage.getItem(chat_id)));

        // messagesEndRef.current?.scrollIntoView({
        //   behavior: "auto",
        //   block: "center",
        //   inline: "center"
        // });
        // des-seta como Loading
        // setLoadingDown(false);

      } catch (error) {
        console.log(error);
      }
    }
    // }

    //pegar o id da ultima mensagem de cima para baixo
  }

  useEffect(() => {
    scrollToBottom();
  }, [chatToBottom]);

  return (
    <div className="received-messages" ref={divMessages} onScroll={e => { handleScroll(e); findRecentMessages(e) }}>
      {messagesList.map(message => renderMessageByType(message))}
      <div ref={messagesEndRef} id="bottom" />
    </div>
  );

}
export default Messages;
